import { createIconInner } from '##/icons/Icon/createIconInner';

import props from './props';
import svg from './svg';

export const Icon3DMap = createIconInner(props, svg);
